import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  InfoCircleOutlined,
} from '@ant-design/icons';
import clsx from 'clsx';
import { cloneElement, isValidElement } from 'react';

import styles from './Alert.module.css';

import type { AlertProps, AlertType, IconElementProps } from './types';

export const DEFAULT_ICON_BY_TYPE: Record<AlertType, React.ReactElement<IconElementProps>> = {
  default: <InfoCircleOutlined aria-hidden className={styles.icon} />,
  error: <CloseCircleFilled aria-hidden className={styles.icon} />,
  info: <InfoCircleFilled aria-hidden className={styles.icon} />,
  success: <CheckCircleFilled aria-hidden className={styles.icon} />,
  warning: <ExclamationCircleFilled aria-hidden className={styles.icon} />,
};

export function getIconElement(type: AlertType, icon: AlertProps['icon']): React.ReactNode {
  if (!icon?.component) {
    return DEFAULT_ICON_BY_TYPE[type];
  }

  if (!isValidElement<IconElementProps>(icon.component)) {
    return icon.component;
  }

  return cloneElement(icon.component, {
    className: clsx(styles.icon, icon.component.props.className),
    style: {
      ...icon.component.props.style,
      ...(icon.size ? { '--icon-size': icon.size } : {}),
    },
  });
}
